export default __webpack_public_path__ + "static/media/Spinner.b767aab4.svg";